import getBasePath from '../../produto/common/functions/api-resource';
import resourceBuilder from '../../produto/common/functions/metadados-resource-builder';

const basePath = getBasePath('planejamento_acao', '');

export default (resource) => resource(`${basePath}`, {}, planejamentoAcaoActions);

export const buscarResumo = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'listagem-akzo/dash/resumo', parametros).doGet();
